import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField, MatInputModule } from '@angular/material/input';
import { Timezone } from '../../../models/property.model';
import { MatSelectModule } from '@angular/material/select';

export interface TimezoneEditData {
  currentValue: string;
  timezones: Timezone[];
}

@Component({
  selector: 'app-timezone-edit',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatFormField,
    MatInputModule,
    MatDialogModule,
    MatDialogContent,
    MatDialogActions,
    FormsModule,
    MatSelectModule
  ],
  templateUrl: './timezone-edit.html',
  styleUrl: './timezone-edit.scss',
})
export class TimezoneEdit implements OnInit {
  dialogRef = inject<MatDialogRef<TimezoneEdit>>(MatDialogRef);
  data = inject<TimezoneEditData>(MAT_DIALOG_DATA);

  timezone = '';
  timezones: Timezone[] = [];
  timezonesLoaded = false;

  ngOnInit(): void {
    console.log(this.data);
    this.timezone = this.data.currentValue || '';
    this.timezones = this.data.timezones || [];
    this.timezonesLoaded = true;
  }

  @Output()
  private _save = new EventEmitter<string>();

  public get save() {
    return this._save;
  }
  public set save(value) {
    this._save = value;
  }

  @Output() cancel = new EventEmitter<void>();
}
